import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService, Resource } from '@app/core/services/base.service';
import { ResourceType } from '@dwo/enums';
import { env } from '../../../environments/env';
import { DocumentDto } from '@app/generated/model';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService extends BaseService {
  constructor(public http: HttpClient) {
    super(http);
  }

  @Resource(ResourceType.LoadWorkOrderDocuments, ['workOrderId'])
  loadWorkOrderDocuments(workOrderId: string): Observable<DocumentDto[]> {
    const encodedId = encodeURIComponent(workOrderId);
    return this.http.get<DocumentDto[]>(`${env.get().api.url}/work-orders/${encodedId}/documents`);
  }
}
